<div class="cardlist-wrapper">
  <ul class="cardlist"
    *ngIf="!loading"
    [ngClass]="{
      'cardlist--search': theme === 'search',
      'cardlist--similar': theme === 'similar',
      'cardlist--home': theme === 'home',
      'cardlist--campaign': theme === 'campaign',
      'cardlist--broker': theme === 'broker',
      'show_grid_3_cols': showGrid3Cols
    }"
    [ngStyle]="theme === 'home' ? {'grid-template-columns': 'repeat(' + sizeCards + ', 1fr)' } : ''"
  >
    <li class="cardlist__item" *ngFor="let card of productCards | slice:0:sizeCards">
      <lps-card-product
        [hideBookmark]="hideBookmark"
        [displayRealtorContactLink]="displayRealtorContactLink"
        [productCard]="card"
        [theme]="theme"
        [target]="target"
        [productBaseLink]="productBaseLink"
        [gridName]="gridName"
        [showGrid3Cols]="showGrid3Cols"
        [showSwiper]="showSwiper"
        [nickname]="nickname"
      ></lps-card-product>
    </li>
  </ul>
</div>

<div class="cardlist-wrapper">
  <ul class="cardlist"
    *ngIf="loading"
    [ngClass]="{
      'cardlist--search': theme === 'search',
      'cardlist--similar': theme === 'similar',
      'cardlist--home': theme === 'home',
      'cardlist--campaign': theme === 'campaign',
      'cardlist--broker': theme === 'broker',
      'show_grid_3_cols': showGrid3Cols
    }"
    [ngStyle]="theme === 'home' ? {'grid-template-columns': 'repeat(' + sizeCards + ', 1fr)' } : ''"
  >
    <li class="cardlist__item" *ngFor="let skeleton of skeletons | slice:0:sizeCards">
      <div class="product-card-skeleton cardlist__skeletons">
        <div class="cardlist__skeletons__column">
          <lps-skeleton-product-card class="skeleton-product-card__table-item"></lps-skeleton-product-card>
          <lps-skeleton-product-card class="skeleton-product-card__table-item"></lps-skeleton-product-card>
          <lps-skeleton-product-card class="skeleton-product-card__table-item"></lps-skeleton-product-card>
        </div>
      </div>
    </li>
  </ul>
</div>
